/* Built In Imports */
/* External Imports */
import { Heading } from '@chakra-ui/react';

/* Internal Imports */
/* Components */
import MidContainer from '@Layout/MidContainer';

/* Services */

/**
 * Renders the LiveStreamDate component.
 *
 * @param {Array} sectionContent - Content from api.
 * @param {string} region - Current User Country.
 * @param {string} lang - Current User Language.
 * @returns {ReactElement} LiveStreamDate Component.
 */

const LiveStreamDate = ({ sectionContent }) => {
  return (
    <MidContainer w="586px">
      <Heading
        as="h6"
        fontWeight="500"
        fontSize={{ base: '26px' }}
        color="#FFFFFF"
        pb={{ base: '30px', md: '40px' }}
        fontFamily="FedraSansStd-book"
        textAlign="center"
        mt="30px"
        px={{ base: '10px', md: 0 }}
      >
        {sectionContent?.text}
      </Heading>
    </MidContainer>
  );
};

export default LiveStreamDate;
